import { cn } from '@/lib/utils';
import type { VerrouInvariant } from '@rosetta/shared';
import type { ReactNode } from 'react';

interface MarqueInvariantProps {
  verrou: VerrouInvariant;
  children: ReactNode;
}

/**
 * An invariant, marked (#9): a light neutral background and a bottom line in bleu nuit, solid
 * for a strict one and dashed for a flexible one. Never the colour of a noyau: the meaning is
 * the lock, and the line tells it (not a colour alone). Black on the background is above
 * 4.5:1 and the line above 3:1 (`tests/contrastes.test.ts`).
 */
export function MarqueInvariant({ verrou, children }: MarqueInvariantProps) {
  return (
    <mark
      className={cn(
        'rounded-sm border-bleu-nuit border-b-2 px-1 text-inherit',
        verrou === 'strict' ? 'border-solid bg-bleu-nuit-tint' : 'border-dashed bg-gray-100',
      )}
    >
      {children}
    </mark>
  );
}
